import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2PersonOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="m26 28-1.4 2H6v-7c0-2.206 1.794-4 4-4h12c2.206 0 4 1.794 4 4v3h-2v-3c0-1.103-.897-2-2-2H10c-1.102 0-2 .897-2 2v5zM8.5 9.5C8.5 5.364 11.864 2 16 2s7.5 3.364 7.5 7.5S20.136 17 16 17s-7.5-3.364-7.5-7.5m2 0c0 3.033 2.468 5.5 5.5 5.5s5.5-2.467 5.5-5.5S19.032 4 16 4s-5.5 2.467-5.5 5.5" /></svg>
);
